import { render, staticRenderFns } from "./ModelOperate.vue?vue&type=template&id=27c20d2d&scoped=true&"
import script from "./ModelOperate.vue?vue&type=script&lang=js&"
export * from "./ModelOperate.vue?vue&type=script&lang=js&"
import style0 from "./ModelOperate.vue?vue&type=style&index=0&id=27c20d2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c20d2d",
  null
  
)

export default component.exports